exports.ToastTypes = {
  Success: "SUCCESS",
  Error: "ERROR",
  Warning: "WARNING",
};
